let UTILS = require("../libs/utils.js");
var v7706;
var v7707;
module.exports = {
  id: "depo",
  name: "Deposit",
  alias: "depo",
  endStats: ["sid", "name", "score", "kills", "deaths", "deposits", "denies", "reward"],
  leaderStats: ["deposits", "kills", "denies", "score"],
  objective: true,
  teams: true,
  tagLimit: 65,
  objScore: 50,
  noScoreC: true,
  tagHoldLimit: 20,
  deposit: true,
  maxPerCluster: 3,
  gameStart: function (p9128) {
    p9128.activeObjective = -1;
    p9128.randObjective(null, true);
  },
  leaderSort: function (p9129, p9130) {
    if (p9129.deposits === p9130.deposits && p9129.kills && p9130.kills) {
      return p9129.kills - p9130.kills;
    } else {
      return p9130.deposits - p9129.deposits;
    }
  },
  endSort: function (p9131, p9132) {
    if (p9131.deposits === p9132.deposits && p9131.kills && p9132.kills) {
      return p9132.kills - p9131.kills;
    } else {
      return p9132.deposits - p9131.deposits;
    }
  },
  winCondition: function (game) {
    var v7708 = game.teamScores[1] || 0;
    var v7709 = game.teamScores[2] || 0;
    if (v7708 == v7709) {
      var vLN01199 = 0;
      var vLN01200 = 0;
      var vLN01201 = 0;
      var vLN01202 = 0;
      var vLN01203 = 0;
      var vLN01204 = 0;
      for (var vLN01205 = 0; vLN01205 < game.players.list.length; ++vLN01205) {
        var v7710 = game.players.list[vLN01205].kills;
        var v7711 = game.players.list[vLN01205].score;
        var v7712 = game.players.list[vLN01205].denies;
        if (game.players.list[vLN01205].team == 1) {
          vLN01201 += v7710;
          vLN01199 += v7711;
          vLN01203 += v7712;
        } else {
          vLN01202 += v7710;
          vLN01200 += v7710;
          vLN01204 += v7712;
        }
      }
      if (vLN01203 == vLN01204) {
        if (vLN01201 == vLN01202) {
          if (vLN01199 > vLN01200) {
            return 1;
          } else {
            return 2;
          }
        } else if (vLN01201 > vLN01202) {
          return 1;
        } else {
          return 2;
        }
      } else if (vLN01203 > vLN01204) {
        return 1;
      } else {
        return 2;
      }
    }
    if (v7708 > v7709) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (p9134) {
    var v7713 = p9134.teamScores[1] || 0;
    var v7714 = p9134.teamScores[2] || 0;
    return !(v7713 >= p9134.mode.tagLimit) && !(v7714 >= p9134.mode.tagLimit);
  }],
  onKill: function (p9135, p9136, p9137, p9138) {
    var v7715 = p9137.dogTags || 0;
    if (p9138 && p9138 != p9137) {
      v7715 += 1;
    }
    if (v7715) {
      var v7716 = p9137.lastGround && (!p9138 || p9138 == p9137 && v7715 > 1);
      if (p9138 && p9138 != p9137 || v7716) {
        if (p9137.lastGround && !p9137.onGround) {
          v7716 = true;
        }
        var vO217 = {
          x: v7716 ? p9137.lastGround.x : p9137.x,
          y: v7716 ? p9137.lastGround.y : p9137.y,
          z: v7716 ? p9137.lastGround.z : p9137.z
        };
        if (v7715 <= p9135.mode.maxPerCluster) {
          p9135.dropSpawnable(3, p9137, {
            c: v7715
          }, vO217);
        } else {
          for (var v7717 = Math.floor(v7715 / p9135.mode.maxPerCluster), v7718 = v7715 % p9135.mode.maxPerCluster, vLN01206 = 0; vLN01206 < v7717; vLN01206++) {
            p9135.dropSpawnable(3, p9137, {
              c: p9135.mode.maxPerCluster
            }, {
              x: vO217.x + UTILS.randInt(-10, 10),
              y: vO217.y,
              z: vO217.z + UTILS.randInt(-10, 10)
            });
          }
          if (v7718) {
            p9135.dropSpawnable(3, p9137, {
              c: v7718
            }, {
              x: vO217.x + UTILS.randInt(-10, 10),
              y: vO217.y,
              z: vO217.z + UTILS.randInt(-10, 10)
            });
          }
        }
      }
    }
  },
  update: function (game, p9140, p9141) {
    if (game.map.manager.objectives.length && game.waitTimers && game.waitTimers[0].contTime && (game.objectiveTimer -= p9141, game.objectiveTimer <= 0)) {
      game.objectiveTimer = 500;
      for (var vLN01207 = 0; vLN01207 < game.map.manager.objectives.length; ++vLN01207) {
        v7706 = game.map.manager.objectives[vLN01207];
        if (v7706 && v7706.uid == game.activeObjective) {
          for (var vLN01208 = 0; vLN01208 < game.players.list.length; ++vLN01208) {
            v7707 = game.players.list[vLN01208];
            if (v7707.active && v7707.dogTags > 0 && v7707.collides(v7706)) {
              v7707.dogTags--;
              v7707.deposits++;
              game.incMedal("Deposited", v7707);
              game.giveTeamScore(v7707.team, 1);
              game.players.score(v7707, game.mode && game.mode.objScore ? game.mode.objScore : 10);
              v7707.send("am", [49, game.mode && game.mode.objScore ? game.mode.objScore : 10, 0, 1]);
              v7707.send("krt", v7707.dogTags);
              game.challenges.update(game, "dep", 1, null, v7707);
            }
          }
        }
      }
    }
  }
};